<template>
  <div style="margin-bottom:3rem">

    <!-- DIALO  WITH OPTIONS  -->
    <v-dialog v-model="show" :class="{'filtr-active':showFilter}" width="1000">
      <v-btn slot="activator" block color="primary">
        {{ $t('archive.filter.new_filter') }}
      </v-btn>
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('archive.filter.new_filter') }}
        </v-card-title>
        <v-container>
          <v-flex xs8>
            <v-text-field v-model="name" :label="`${$t('archive.name')}`" required></v-text-field>
          </v-flex>
          <div>
            <div>
              <h3> {{ $t('archive.filter.contains') }} : </h3>
              <div v-for="i in rangeContains" :key="i">
                <v-layout>
                  <v-flex v-if="i!=1" sm3 xs5>
                    <v-select v-model="operatorsContains[i]" :items="operators" :label="`${$t('archive.filter.operator')}`" item-text="name"
                              item-value="value" prepend-icon="xxyyzz"
                              style="margin-left:2rem;"></v-select>
                  </v-flex>
                  <v-flex sm3 xs5>
                    <v-text-field v-model="searchContains[i]" :label="`${$t('archive.filter.phrase')}`" prepend-icon="search"
                                  required style="margin-left:2rem;"></v-text-field>
                  </v-flex>
                  <v-flex sm1 xs2>
                    <v-btn v-if="i!=1" block fab small style="margin-left:2rem;" @click="removeFiltrContains(i)">
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex v-if="i==rangeContains" sm2 xs2>
                    <v-btn fab small @click="rangeContains++">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </div>

            <div>
              <h3> {{ $t('archive.filter.not_contains') }} : </h3>
              <div v-for="i in rangeNot" :key="i">
                <v-layout>
                  <v-flex v-if="i!=1" sm3 xs5>
                    <v-select v-model="operatorsNot[i]" :items="operators" :label="`${$t('archive.filter.operator')}`" item-text="name"
                              item-value="value" prepend-icon="xxyyzz"
                              style="margin-left:2rem;"></v-select>
                  </v-flex>
                  <v-flex sm3 xs5>
                    <v-text-field v-model="searchNot[i]" :label="`${$t('archive.filter.phrase')}`" prepend-icon="search"
                                  required style="margin-left:2rem;"></v-text-field>
                  </v-flex>
                  <v-flex sm1 xs2>
                    <v-btn v-if="i!=1" block fab small style="margin-left:2rem;" @click="removeFiltrNot(i)">
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex v-if="i==rangeNot" sm2 xs2>
                    <v-btn fab small @click="rangeNot++">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>

          <!--  FILTRACJA   -->
          <v-layout style="margin-top:1rem">
            <v-flex xs4>
              <v-text-field v-model="type" :label="`${$t('archive.arch_type')}`" required></v-text-field>
            </v-flex>
          </v-layout>

          <v-btn @click="save">
            {{ $t('archive.filter.save') }}
          </v-btn>

          <!-- KONIEC FILTRACJI -->
        </v-container>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      name: "",
      show: false,
      type: "",
      searchContains: [],
      rangeContains: 1,
      operatorsContains: [],
      searchNot: [],
      rangeNot: 1,
      operatorsNot: [],
      createFiltrer: true,
      sort: 1,
      place: 2,
      showFilter: false,
      operators: [{
        name: "AND",
        value: "AND"
      },
      {
        name: "OR",
        value: "OR"
      }
      ],
      filters: [],
      baseFilter: [{
        name: this.$t('archive.filter.new'),
        id: 0
      }],
      choosenFilter: 0
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  created() {
  },
  methods: {
    removeFiltrContains(index) {
      this.operatorsContains.splice(index, 1);
      this.searchContains.splice(index, 1)
      this.rangeContains--;
    },
    removeFiltrNot(index) {
      this.operatorsNot.splice(index, 1);
      this.searchNot.splice(index, 1)
      this.rangeNot--;
    },
    buildCondition() {
      let condition = {
        "name": this.name,
        "type": this.type
      }
      condition["contains"] = this.buildConditionFromData(this.searchContains, this.operatorsContains, this.rangeContains)
      condition["not"] = this.buildConditionFromData(this.searchNot, this.operatorsNot, this.rangeNot)
      return condition
    },
    buildConditionFromData(search, operatos, range) {
      let condition = []

      for (let i = 0; i <= range; i++) {
        if (search[i] == undefined || (operatos[i] == undefined && i > 1)) { // Ignore if search is empty or operator is empty when is needed (any field axcept first)
          continue;
        }
        let objCondition = {
          "id": i,
          search: search[i]
        }

        if (i > 1) {
          objCondition.operator = operatos[i]
        }
        condition.push(objCondition)
      }
      return condition
    },
    save() {
      let filters = this.buildCondition();
      if ((Object.keys(filters.contains).length > 0 || Object.keys(filters.not).length > 0 || this.type != "") && this.name.length > 3) {
        this.$store.dispatch('createArchiveFilter', filters).then(data => {
          this.show = false
          this.clearConditions()
          this.showMessage(this.$t('archive.filter.created'), "success")
          this.$emit('filter', data)
        }).catch(() => {
          this.showMessage(this.$t('archive.filter.cannot_create'), "danger")
        })
      } else {
        this.showMessage(this.$t('archive.filter.invalid_form'), "danger")
      }
    },
    clearConditions() {
      this.searchNot = []
      this.rangeNot = 1;
      this.operatorsNot = []

      this.searchContains = []
      this.rangeContains = 1;
      this.operatorsContains = []
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  },
}
</script>

<style>
.filtr-active {
  background-color: green !important;
}
</style>
